(ns practitest.frontend.forms3.entity-form.traceability-scope-utils
  (:require
    [practitest.frontend.common.mixpanel :as mixpanel]
    [practitest.frontend.common.i18n :refer [get-translation
                                             format-translation]]
    [practitest.frontend.components.grid.events :as grid.events]
    [practitest.frontend.components.grid.localstorage :as grid-storage]
    [practitest.frontend.components.grid.sessionstorage :as grid-session-storage]
    [practitest.frontend.components.modal :as modal]
    [practitest.frontend.components2.buttons :as buttons]
    [practitest.frontend.requirements.events :as requirements-events]
    [re-frame.core :as re-frame]))

(defn switch-to-tests [state-key active-scope-atom requirement-id]
  (reset! active-scope-atom :test)
  (grid-session-storage/save-traceability-scope :test requirement-id)
  (re-frame/dispatch [::requirements-events/on-testing-scope-change "LAST_RUN"])
  (re-frame/dispatch [::grid.events/clear-selection [:requirement state-key]])
  (mixpanel/track "Traceability Scope" {:Action "Latest Run" :Entity "Requirement"}))

(defn switch-to-testsets [state-key active-scope-atom requirement-id]
  (reset! active-scope-atom :testset)
  (grid-session-storage/save-traceability-scope :testset requirement-id)
  (re-frame/dispatch [::requirements-events/on-testing-scope-change "TESTSETS"])
  (re-frame/dispatch [::grid.events/clear-selection [:requirement state-key]])
  (mixpanel/track "Traceability Scope" {:Action "Test Set" :Entity "Requirement"}))

(defn confirm-scope-change-modal [is-testset? show? state-key active-scope-atom requirement-id]
  [modal/bootstrap-modal
   {:is-open? @show?
    :on-request-close #(reset! show? false)
    :centered? true
    :close-button? true}
   (get-translation "requirement.traceability.confirm-linkage-change-title" "Confirm Linkage Type Change")
   [:div
    [:p (format-translation
          (get-translation "requirement.traceability.confirm-linkage-change"
                           "You are requesting to change the linkage to '%{new_entity}'.
                           This will unlink the currently linked %{current_entity}. Do you approve?")
          (if is-testset?
            {:new_entity "Tests" :current_entity "Test Set"}
            {:new_entity "Test Sets" :current_entity "Tests"}))]]
   [:div.modal-buttons
    [buttons/button
     {:text "Cancel"
      :on-click #(reset! show? false)}]
    [buttons/button
     {:text "Approve"
      :primary? true
      :on-click (fn []
                  (reset! show? false)
                  (if is-testset?
                    (switch-to-tests state-key active-scope-atom requirement-id)
                    (switch-to-testsets state-key active-scope-atom requirement-id)))}]]])

(defn define-linkage-modal [show? state-key active-scope-atom requirement-id]
  [modal/bootstrap-modal
   {:is-open? @show?
    :on-request-close #(reset! show? false)
    :centered? true
    :close-button? true}
   (get-translation "requirement.traceability.define-linkage-title" "Define Test Set Linkage")
   [:div
    [:p (get-translation "requirement.traceability.define-linkage"
                         "You are requesting to define the linkage to 'Test Sets'.
                         This will link all the tests related to this Test Set - both current and future changes.
                         Do you approve?")]
    [:div.m-checkbox-container
     [:input.m-checkbox
      {:type "checkbox"
       :id "dont-show-again"
       :on-change (fn [e]
                    (let [checked (-> e .-target .-checked)]
                      (grid-storage/save-hide-define-linkage-message checked)))}]
     [:label {:for "dont-show-again"}
      (get-translation "generic.dont-show-again" "Don't show this message again")]]]
   [:div.modal-buttons
    [buttons/button
     {:text "Cancel"
      :on-click #(reset! show? false)}]
    [buttons/button
     {:text "Approve"
      :primary? true
      :on-click (fn []
                  (reset! show? false)
                  (switch-to-testsets state-key active-scope-atom requirement-id))}]]])
